import { render, staticRenderFns } from "./ProgramacionOrdenesSop.vue?vue&type=template&id=dc2fb506"
import script from "./ProgramacionOrdenesSop.vue?vue&type=script&lang=js"
export * from "./ProgramacionOrdenesSop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports